import LeadAssignmentsCRUDActions from '../actions/LeadAssignmentsCRUDActions';
import { sortBy } from 'lodash';
import Actions from '../actions/actions';
import {
  LeadAssignment,
  LeadAssignmentsState,
} from '../interfaces/leadAssignments';
import { setBusy, setUnBusy } from './common/commonReducers';

const initialState: LeadAssignmentsState = {
  busy: false,
  entities: [],
};

const retrievedAll = (
  state: LeadAssignmentsState,
  action: { entities: LeadAssignment[] },
) => {
  const { entities } = action;
  return {
    ...state,
    busy: false,
    entities: sortBy(entities, 'sortOrder'),
  };
};

export default function leadAssignments(state = initialState, action: any) {
  switch (action.type) {
    case LeadAssignmentsCRUDActions.busyAction:
      return setBusy(state);
    case LeadAssignmentsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case LeadAssignmentsCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
